import PropTypes from 'prop-types';
import React from 'react';
import {map} from 'lodash';
import Carousel from 'shared/components/carousel';
import CollegeApplicationStatusCard from 'shared/college-application-status/components/college-application-status-card';
import './college-application-status-cards.scss';

class CollegeApplicationStatusCards extends React.Component {
  static propTypes = {
    colleges: PropTypes.arrayOf(PropTypes.object).isRequired,
    collegeApplicationStatuses: PropTypes.object.isRequired,
    setCollegeAppStatus: PropTypes.func.isRequired,
  };

  render() {
    const {colleges, collegeApplicationStatuses, setCollegeAppStatus} = this.props;

    return (
      <div className="college-application-status-cards">
        <Carousel>
          {map(colleges, (college) => (
            <CollegeApplicationStatusCard
              key={college._id}
              college={college}
              collegeApplicationStatus={collegeApplicationStatuses[college._id]}
              setCollegeAppStatus={setCollegeAppStatus}
              questionButtonOnClick={this.nextCollegeApp}
            />
          ))}
        </Carousel>
      </div>
    );
  }
}

export default CollegeApplicationStatusCards;
